module.exports = __webpack_public_path__ + "img/lgd.c94021b7.png";